export default __webpack_public_path__ + "static/media/FAQ_15_4.853d63cf.png";